import React from 'react';

const IndustryIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <g clipPath='url(#clip0_545_84209)'>
            <path
                d='M11.3335 11.9999H12.0002M8.00016 11.9999H8.66683M4.66683 11.9999H5.3335M1.3335 13.3333C1.3335 13.6869 1.47397 14.026 1.72402 14.2761C1.97407 14.5261 2.31321 14.6666 2.66683 14.6666H13.3335C13.6871 14.6666 14.0263 14.5261 14.2763 14.2761C14.5264 14.026 14.6668 13.6869 14.6668 13.3333V5.33325L10.0002 8.66659V5.33325L5.3335 8.66659V2.66659C5.3335 2.31296 5.19302 1.97382 4.94297 1.72378C4.69292 1.47373 4.35378 1.33325 4.00016 1.33325H2.66683C2.31321 1.33325 1.97407 1.47373 1.72402 1.72378C1.47397 1.97382 1.3335 2.31296 1.3335 2.66659V13.3333Z'
                stroke='#00225F'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_545_84209'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { IndustryIcon };
